import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function WorldMapStats () {
    useGSAP(() => {
        gsap.from('.wos-map-reveal', {
            opacity: 0,
            x: 200,
            duration: 0.8,
            stagger: 0.2,
            scrollTrigger: {
                trigger: '.wos-map',
                start: 'top center',
                end: 'bottom center',
                scrub: false,
                toggleActions: 'play none play reverse',
                markers: false
            },
        });
    }, []);
    return <>
        <div className='relative bg-[#1d1d39] overflow-x-hidden 2xl:h-[600px] xl:h-[500px] lg:h-[406px] wos-map'>
            <img src="/worldMap.webp" alt="word map" className='lg:w-auto w-full lg:h-full relative lg:left-0 left-[-20%]'/>
            <div className='lg:w-5/6 lg:mx-auto lg:my-auto lg:max-w-[1200px] lg:absolute lg:top-[50%] lg:left-[50%] lg:transform lg:translate-x-[-50%] lg:translate-y-[-50%] z-0 lg:p-0 lg:m-0 lg:pt-8 pt-[5rem] pb-16 xl:w-full xl:px-[10vw] xl:max-w-[unset] 2xl:px-[15vw]' >
                <div className="flex flex-col w-max lg:ml-auto lg:mr-0 m-auto xl:gap-[1.5rem]">
                    <div className='text-white md:text-4xl font-semibold text-center text-3xl'>Wall Of Share c'est :</div>
                    <div className='md:w-[28rem] my-4 grid md:grid-cols-2 grid-col-1 lg:gap-y-14 gap-y-10 w-max mx-auto'>
                        <div className="wos-map-reveal">
                            <div className='text-6xl font-bold text-center bg-clip-text bg-gradient-to-r from-[#805ad5] via-red-500 to-[#ed8936] text-transparent w-max mx-auto'>+1000</div>
                            <div className='font-semibold text-white text-center w-max mx-auto'>compétences</div>
                        </div>
                        <div className="wos-map-reveal">
                            <div className='text-6xl font-bold text-center bg-clip-text bg-gradient-to-r from-[#805ad5] via-red-500 to-[#ed8936] text-transparent w-max mx-auto'>+150</div>
                            <div className='font-semibold text-white text-center w-max mx-auto'>domaines</div>
                        </div>
                        <div className="wos-map-reveal">
                            <div className='text-6xl font-bold text-center bg-clip-text bg-gradient-to-r from-[#805ad5] via-red-500 to-[#ed8936] text-transparent w-max mx-auto'>98%</div>
                            <div className='font-semibold text-white text-center text-md w-max mx-auto'>clients satisfaits</div>
                        </div>
                        <div className="wos-map-reveal">
                            <div className='text-6xl font-bold text-center bg-clip-text bg-gradient-to-r from-[#805ad5] via-red-500 to-[#ed8936] text-transparent w-max mx-auto'>94%</div>
                            <div className='font-semibold text-white text-center w-max mx-auto'>de freelances<br/>recommandent WOS</div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </>;
}